import { Button, Avatar } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { useState } from "react";
import CommentItem from "./CommentItem";
import MentionEditor from "../../common/MentionEditor";

const isEditorContentEmpty = (html = "") => {
  const stripped = String(html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
  return !stripped;
};

const CommentsSection = ({
  comments,
  loading = false,
  onAdd,
  onEdit,
  onDelete,
  user,
  mentionUsers = [],
}) => {
  const { firstName, lastName } = user || {};
  const fullName = `${firstName} ${lastName}`;

  const [newComment, setNewComment] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState("");

  const handleAddComment = async () => {
    if (isEditorContentEmpty(newComment)) return;

    await onAdd(newComment);
    setNewComment("");
  };

  const handleDelete = async (id) => {
    await onDelete(id);
  };

  const handleEditSave = async (id) => {
    await onEdit(id, editingText);
    setEditingId(null);
    setEditingText("");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {/* Comment Form */}
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "flex-start",
        }}
      >
        <Avatar>
          {firstName?.charAt(0).toUpperCase()}
          {lastName?.charAt(0).toUpperCase()}
        </Avatar>
        <div style={{ flex: 1 }}>
          <MentionEditor
            value={newComment}
            onChange={setNewComment}
            placeholder="Write a comment..."
            users={mentionUsers}
            debugId="TaskDrawer:NewComment"
            className="mb-0"
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 8,
            }}
          >
            <Button
              type="primary"
              icon={<SendOutlined />}
              onClick={handleAddComment}
              disabled={loading || isEditorContentEmpty(newComment)}
            >
              Comment
            </Button>
          </div>
        </div>
      </div>

      {/* Comments List */}
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        {comments?.map((comment) => (
          <CommentItem
            key={comment.id}
            comment={comment}
            user={fullName}
            editingId={editingId}
            setEditingId={setEditingId}
            editingText={editingText}
            setEditingText={setEditingText}
            mentionUsers={mentionUsers}
            onDelete={handleDelete}
            onSave={handleEditSave}
          />
        ))}
      </div>
    </div>
  );
};

export default CommentsSection;
